/**
 * Disclaimer — web port of the RN `Disclaimer` in
 * `apps/WunderGuide/components/AudioChat.tsx` (line 41).
 *
 * Server-driven text from `serverHints.disclaimer` in the REST /start
 * response. Falls back to the bundled DISCLAIMER translation when the
 * server didn't send one (older agents, fallback agents, etc.).
 *
 * Styling matches RN: 12px centered, ~70% opacity, balanced wrap,
 * positioned absolutely at the bottom of the mic area by the parent.
 */
import { useLanguage } from '../hooks/useLanguage';
import './Disclaimer.css';

interface DisclaimerProps {
  text?: string;
}

export default function Disclaimer({ text }: DisclaimerProps) {
  const { t } = useLanguage();
  const value = text ?? t('DISCLAIMER');
  if (!value) return null;
  return (
    <div className="wg-disclaimer__wrap" role="note" aria-label="AI disclaimer">
      <p className="wg-disclaimer__text">{value}</p>
    </div>
  );
}
